import ButtonCellLabel from "./ButtonCellLabel";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("Label", ButtonCellLabel);
